const initialState = {
  queue: [],
  isShuffled: false,
  shuffleOrder: null,
  listPosition: 0,
  willPlay: false,
  repeatState: "false",
  volume: 1,
};

export default initialState;
